var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheme = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "scheme") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-515.000000, -191.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "scheme",
  transform: "translate(515.000000, 191.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,4 C17.78,4 16,5.78 16,8 L16,14 C16,16.22 17.78,18 20,18 L22,18 L22,22 L4,22 L4,26 L12,26 L12,30 L10,30 C7.78,30 6,31.78 6,34 L6,40 C6,42.22 7.78,44 10,44 L18,44 C20.22,44 22,42.22 22,40 L22,34 C22,31.78 20.22,30 18,30 L16,30 L16,26 L32,26 L32,30 L30,30 C27.78,30 26,31.78 26,34 L26,40 C26,42.22 27.78,44 30,44 L38,44 C40.22,44 42,42.22 42,40 L42,34 C42,31.78 40.22,30 38,30 L36,30 L36,26 L44,26 L44,22 L26,22 L26,18 L28,18 C30.22,18 32,16.22 32,14 L32,8 C32,5.78 30.22,4 28,4 L20,4",
  id: "Shape",
  fill: "#1BA785",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheme);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scheme.00420060b0281a601e4dfbfb5b97589b.svg";